import { render, staticRenderFns } from "./VueAudio.vue?vue&type=template&id=23c43786&scoped=true&"
import script from "./VueAudio.vue?vue&type=script&lang=js&"
export * from "./VueAudio.vue?vue&type=script&lang=js&"
import style0 from "./VueAudio.vue?vue&type=style&index=0&id=23c43786&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c43786",
  null
  
)

component.options.__file = "VueAudio.vue"
export default component.exports